<template>
    <b-modal size="xl" title="Reporte de avisos prioritarios" id="RDAP" v-model="show" no-close-on-backdrop scrollable>
        <b-row>
            <div v-if="isLoading" class="d-flex justify-content-center aling-items-center">
                <img src="assets/img/loader.gif" alt="Loading..." />
            </div>
            <b-col v-else>
                <b-button 
                    variant="outline-secondary" 
                    @click="onSaveOrden"
                    :disabled="payload.items.length === 0"
                    >
                    <i class="flaticon2-start-up text-primary"></i>
                    Guardar Orden
                </b-button>
                <DxDataGrid :data-source="items" :show-borders="true" :show-column-lines="true" :show-row-lines="true"
                    :row-alternation-enabled="true" :columnAutoWidth="true" :allow-column-resizing="true"
                    :allow-column-reordering="true" id="TRDAP">
                    <DxExport :enabled="true" />
                    <DxRowDragging :allow-reordering="true" :on-reorder="onReorder" :show-drag-icons="true" />
                    <DxColumnChooser emptyPanelText="Arrastre una columna aquí para ocultar" :enabled="true"
                        title="Arrastre columna aquí..." />
                    <DxColumnFixing :enabled="true" />
                    <DxGroupPanel :visible="false" emptyPanelText="Arrastre una columna aquí para agrupar" />
                    <DxSearchPanel :visible="true" :width="240" placeholder="Buscar..." />
                    <DxPaging :page-size="30" />
                    <DxPager :visible="true" infoText="Página {0} de {1} ({2} registros)"
                        :allowed-page-sizes="[5, 15, 30, 50, 'all']" display-mode="full" :show-page-size-selector="true"
                        :show-info="true" :show-navigation-buttons="true" />
                    <DxHeaderFilter :visible="true" :allowSearch="true" />
                    <DxGroupPanel :visible="true" />

                    <DxColumn alignment="center" caption="Orden" data-field="orden" />
                    <DxColumn alignment="center" caption="Aviso" data-field="num_aviso" />
                    <DxColumn alignment="center" caption="Tipo Aviso" data-field="tipo_aviso" />
                    <DxColumn alignment="center" caption="Sector" data-field="sector" />
                    <DxColumn alignment="center" caption="Subestacion" data-field="subestacion" />
                    <DxColumn alignment="center" caption="Circuito" data-field="circuito_sm" />
                    <DxColumn alignment="center" caption="Departamento" data-field="departamento" />
                    <DxColumn alignment="center" caption="Cab. Municipal" data-field="cab_municipal" />
                    <DxColumn alignment="center" caption="Barrio" data-field="barrio" />
                    <DxColumn alignment="center" caption="Direccion" data-field="dir_suscriptor" />

                </DxDataGrid>
            </b-col>
        </b-row>
    </b-modal>
</template>
<style>
.cell-grouping-tech {
    background-color: #062863 !important;
    color: #f9db5c !important;
}
</style>
<script>
import {
    DxDataGrid,
    DxPaging,
    DxSearchPanel,
    DxHeaderFilter,
    DxPager,
    DxExport,
    DxGroupPanel,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxRowDragging
    //   DxItem,
} from "devextreme-vue/data-grid";
// import { DxButton } from "devextreme-vue/button";
import axios from "axios";
export default {
    components: {
        DxDataGrid,
        DxPaging,
        DxSearchPanel,
        DxHeaderFilter,
        DxPager,
        DxExport,
        DxGroupPanel,
        DxColumn,
        DxColumnChooser,
        DxColumnFixing,
        DxRowDragging,
        // DxItem,
    },
    data() {
        return {
            show: false,
            isLoading: false,
            items: [],
            columns: [],
            payload: {
                brigada: "",
                items: []
            },
        };
    },
    methods: {
        async onGetAvisos(id_brigade) {
            try {
                this.isLoading = true;
                const { data, status } = await axios.get(`/avisos/brigada/${id_brigade}`);
                if (status === 200 && data.message === "success") {
                    this.items = data.record;
                }
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        onReorder(event) {
            const visibleRows = event.component.getVisibleRows();
            const toIndex = this.items.findIndex((item) => item.num_aviso === visibleRows[event.toIndex].data.num_aviso);
            const fromIndex = this.items.findIndex((item) => item.num_aviso === event.itemData.num_aviso);
            const newTasks = [...this.items];
            newTasks.splice(fromIndex, 1);
            newTasks.splice(toIndex, 0, event.itemData);
            this.items = newTasks;
            this.payload.brigada = this.items[0].brigada;
            this.payload.items = this.items.map((i) => ({ orden: i.orden, id_aviso: i.id_aviso, num_aviso: i.num_aviso }));
        },
        async onSaveOrden() {
            const { isConfirmed } = await this.$swal.fire({
            title: "Información",
            text: `¿Quiere establecer el siguiente ordern de avisos prioritarios?`,
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Si, Confirmar!`,
            cancelButtonText: "Cancelar",
          });
          if (isConfirmed) {
              try {
                  this.isLoading = true;
                  const { data, status } = await axios.put(`/avisos-prioridad/${this.payload.brigada}`, { items: this.payload.items });
                  if (status === 200 && data.message === "success") {
                      this.$swal
                          .fire({
                              title: `Avisos Ordenados`,
                              text: `Avisos ordenados correctamente`,
                              icon: "success",
                              confirmButtonColor: "#3085d6",
                              confirmButtonText: "Ok!",
                          })
                      this.items = data.record;
                  }
                  this.isLoading = false;
              } catch (error) {
                  console.log(error);
                  this.isLoading = false;
              }
          }
        }
    }
};
</script>
